<script setup>
import DateTimeHeader from "./DateTimeHeader.vue";
import { defineProps } from "vue";

const props = defineProps({
  name: String,
});
</script>

<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <DateTimeHeader />
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
            <li class="breadcrumb-item"><a href="#">...</a></li>
            <li class="breadcrumb-item active">{{ props.name }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>
